export default "__VITE_ASSET__lQobkF$1__"